import React from "react";
import ReactLoading from "react-loading";
import { animated, useTransition } from "react-spring";
import "../styles.modules.css";
import { SmallSection } from "./Generics";
import { styled } from "@material-ui/core/styles";

const SpinnerRoot = styled("div")(({ theme }) => ({
  height: "30px",
  width: "30px",
  marginLeft: "1rem",
}));

function SmallSpinner() {
  const transitions = useTransition(true, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  return transitions.map(
    ({ item, key, props }) =>
      item && (
        <SpinnerRoot key={key}>
          <animated.div style={props}>
            <SmallSection>
              <ReactLoading color="#2c3e51" type={"spin"} />
            </SmallSection>
          </animated.div>
        </SpinnerRoot>
      )
  );
}

export default SmallSpinner;
